module.exports = __webpack_public_path__ + "img/CS48Q-中_12.ca0b2ee3.jpg";